export const OPTIONS_SUIVI = {
    SET_MODAL: 'OPTIONS_SUIVI_SET_MODAL',
    SET_EMAIL_SUIVI: 'OPTIONS_SET_EMAIL_SUIVI',
    SET_EMAIL: 'OPTIONS_SET_EMAIL',
    RESET: 'OPTIONS_RESET',
};
